import * as Yup from 'yup';

export default Yup.object({
  source: Yup.string().required('È necessario selezionare la sorgente dell\'interesse'),
});
